"use strict";

if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react-router.min.js");
} else {
  module.exports = require("./cjs/react-router.js");
}



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/react-router/index.js
// module id = 76
// module chunks = 0